// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag0WINKEsjroQcMyKHVe{margin-top:40px;margin-bottom:-2px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/pages/calling/ui/EnableCnamCallerId/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,kBAAA","sourcesContent":[".image {\n  margin-top: 40px;\n  margin-bottom: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `ag0WINKEsjroQcMyKHVe`
};
export default ___CSS_LOADER_EXPORT___;
